/**
 * Coverage lines the Renewal Management → Opportunities tab treats as
 * "core". A client is a cross-sell opportunity when it has at least one
 * active client plan but is missing one or more of these lines; every
 * number on that tab (coverage gaps, clients with gaps, quick wins, most
 * common gap, completeness "N of M lines") derives from this list.
 *
 * This is plain configuration, not AI — edit the list to change what the
 * tab considers. `type` must match `plans.type` values (see
 * PLAN_TYPE_OPTIONS in shared/schemas/plans.ts); "medical" plans are
 * normalized to "health" before comparison.
 *
 * Ancillary lines (STD/LTD, accident, critical illness, hospital indemnity,
 * telehealth, legal, ID theft, …) are deliberately NOT core: adding one here
 * flags every client without it as a gap. Add a second tier below when the
 * team decides which ancillary lines to recommend per client.
 */
export const CORE_COVERAGE_LINES = [
  { type: "health", label: "Medical" },
  { type: "dental", label: "Dental" },
  { type: "vision", label: "Vision" },
  { type: "life", label: "Life" },
] as const;

export const CORE_COVERAGE_TYPES: string[] = CORE_COVERAGE_LINES.map((l) => l.type);

/** "Medical, Dental, Vision, Life" — for UI copy that explains the rule. */
export const CORE_COVERAGE_LABELS = CORE_COVERAGE_LINES.map((l) => l.label).join(", ");
